export default __webpack_public_path__ + "static/media/Sage's Pauldrons of the Aureate.37c9561e.jpg";